import styles from './SongData.module.css';
import { Image, SkeletonizedValue } from '@round/ui-kit';
import { MediaBadge } from '@round/whitelabel-ui';
import { useSong, useMusicSong } from '@round/creatorbase-helpers/api-hooks';

type Props = {
    songId: number | null | undefined;
};

const SongData = ({ songId }: Props) => {
    const { data: song, isLoading: isSongLoading } = useSong(songId);
    const { data: musicSong, isLoading: isMusicSongLoading } = useMusicSong(song?.music_song_id);

    const isLoading = isSongLoading || (!!song?.music_song_id && isMusicSongLoading);
    const isInitialized = !isLoading;

    return (
        <div className={styles.container}>
            <Image
                skeletonCircle={false}
                src={musicSong?.image ?? ''}
                alt={musicSong?.title || song?.title}
                className={styles.image}
                loading={!isInitialized}
            />

            <div className={styles.details}>
                <div>
                    <p className={styles.title}>
                        <SkeletonizedValue isInitialized={isInitialized} width="10rem">
                            {musicSong?.title || song?.title}
                        </SkeletonizedValue>
                    </p>
                    <p className={styles.authorName}>
                        <SkeletonizedValue isInitialized={isInitialized} width="7rem">
                            {musicSong?.artists.map((a) => a.name).join(', ') || song?.artist_name}
                        </SkeletonizedValue>
                    </p>
                </div>

                <div className={styles.badges}>
                    <MediaBadge type="song" />
                    {song?.status === 'released' && <MediaBadge type="released" />}
                </div>
            </div>
        </div>
    );
};

export default SongData;
